// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getProjectFiles } from '@/project/api/get-project-files';
import { useQuery } from '@tanstack/react-query';

interface UseProjectFilesOptions {
  /** The key of the project to fetch files for */
  projectKey: string;
}

/**
 * Hook to fetch files associated with a project.
 * Uses a regular query (not suspense) to allow graceful error handling
 * without crashing the entire page.
 *
 * @param options - Options including the project key
 * @returns The files, loading state, error state, and query methods
 */
export function useProjectFiles(options: UseProjectFilesOptions) {
  const { data, isLoading, isError, error, refetch, ...query } = useQuery({
    queryKey: ['project', options.projectKey, 'file'],
    queryFn: () => getProjectFiles(options.projectKey),
  });

  return {
    files: data?.data ?? [],
    isLoading,
    isError,
    error,
    refetch,
    ...query,
  };
}
